import {useAtomValue} from "jotai";
import {Loadable} from "jotai/vanilla/utils/loadable";
import {Stack, Typography} from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import {ResourceException} from "../../types/resourceError";
import {activeFieldLoadable} from "../../store/activeFieldStore";
import {Field} from "../../types/domain/field";
import {FieldIcon} from "../icons/FieldIcon";

export const ParcelHeader: React.FC = () => {
    const fieldState = useAtomValue(activeFieldLoadable);
    const field = fieldState.state === "hasData" && fieldState.data !== undefined ? fieldState.data : undefined;

    return (
        <Stack direction="column" gap="1rem">
            <Stack direction="row" alignItems="center" justifyContent="space-between">
                <Stack direction="row" alignItems="center" gap="1.125rem">
                    {field && (
                        <FieldIcon
                            sx={{
                                width: "1.6rem",
                                height: "1.6rem",
                                stroke: "#5161C1",
                                strokeWidth: "2.2",
                            }}
                        />
                    )}
                    {fieldState.state === "hasError" && (
                        <ErrorIcon
                            sx={{
                                height: 36,
                                width: 36,
                            }}
                            color="error"
                        />
                    )}
                    <Typography fontSize={30} lineHeight={1.27} fontWeight={700}>
                        {renderTitle(fieldState)}
                    </Typography>
                </Stack>
            </Stack>
        </Stack>
    );
};

const renderTitle = (fieldState: Loadable<Promise<Field | undefined>>): React.ReactNode => {
    if (fieldState.state === "hasData" && fieldState.data) {
        return fieldState.data.name.split("_").shift();
    } else if (fieldState.state === "hasError") {
        return (fieldState.error as ResourceException).resourceError.message;
    } else {
        return null;
    }
};
